import { render } from "./page_row.vue?vue&type=template&id=3beda3b6&scoped=true&lang=pug"
import script from "./page_row.vue?vue&type=script&lang=js"
export * from "./page_row.vue?vue&type=script&lang=js"

import "./page_row.vue?vue&type=style&index=0&id=3beda3b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3beda3b6"]])

export default __exports__